<div class="severity severity-{{ severity }}">
  <svg aria-hidden="true" focusable="false" viewBox="0 0 512 512">
    <use *ngIf="severity === $severity.critical" xlink:href="#exclamation-triangle"></use>
    <use *ngIf="severity !== $severity.critical" xlink:href="#exclamation-circle"></use>
  </svg>
  <div class="content .severity">
    {{ 'scan_issue_severity_' + severity | translate }}
  </div>
</div>
